import getReportingOption from '../store/store';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import ReportingOptionState from 'owa-reporting-option/lib/store/schema/ReportingOptionState';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';

export interface ReportingOptionDirtyState {
    reportingOption: ReportingOptionState;
    userConfiguration: OwaUserConfiguration;
}

export default select<ReportingOptionDirtyState>({
    reportingOption: () => getReportingOption(),
    userConfiguration: () => getUserConfiguration(),
})(function isReportingOptionDirty(state?: ReportingOptionDirtyState) {
    let { reportingOption, userConfiguration } = state;

    // Check values in reportingOption from store and compare against userConfiguration.
    // If any of these values differ, options page will be dirty.
    return (
        (reportingOption.reportJunkSelected !== null &&
            reportingOption.reportJunkSelected !==
                userConfiguration.UserOptions.ReportJunkSelected) ||
        (reportingOption.checkForReportJunkDialog !== null &&
            reportingOption.checkForReportJunkDialog !==
                userConfiguration.UserOptions.CheckForReportJunkDialog)
    );
});
